// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4fe4b9f3] .search-template:not(.active) path{stroke:#333;stroke-width:1px}", ""]);
// Exports
module.exports = exports;
